<template>
  <div class="diary-image-upload" @mousedown.stop>
    <button type="button" @click="openUpload">
      Upload new files
    </button>
    <button type="button" @click="openGallery">
      From Gallery
    </button>
  </div>
</template>

<script>
import { mdiImageOutline } from '@mdi/js'

export default {
  title: 'diaryImage',
  description: 'Insert Image',
  icon: `<svg viewBox="0 0 24 24"><path d="${mdiImageOutline}" /></svg>`,
  props: {
    options: { type: Object, required: true },
  },
  methods: {
    openUpload() {
      this.$parent.closeDashboard()
      this.options.onOpenUpload()
    },
    openGallery() {
      this.$parent.closeDashboard()
      this.options.onOpenGallery()
    },
  },
}
</script>

<style scoped>
.diary-image-upload {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  max-width: 75vw;
}
</style>
